module.exports = __webpack_public_path__ + "./images/Ambientacion.71963c8a4c31f45a6e3c6a177e0cc400.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Ambientacion.png
// module id = ./websources/public/images/Ambientacion.png
// module chunks = 0